<template>
<v-container class="pt-0">
  <h2 class="page-head"><span class="page-heading">Introduction</span></h2>

  <v-expansion-panel>
    <v-expansion-panel-content expand-icon="expand_more" v-for="item in items"
            :key="item.title">
      <div slot="header" class = "blue--text text--darken-4 subheading">{{ item.title }}</div>
      <v-card class="pl-4">
          <p><span v-html="item.content"></span></p>
      </v-card>
    </v-expansion-panel-content>
    </v-expansion-panel>

</v-container>

</template>

<script>
  const MAX_LEVEL_TEXT = process.env.GAME_LEVELS_TXT

  export default {
    name: 'Introduction',
    props: {
      msg: String
    },
    data () {
      return {
        items: [{
          title: `Welcome to the Safe Food Handler program — and app!`,
          content: `The app implements and guides you to the completion of the Safe Food Handler program. ${MAX_LEVEL_TEXT} food-safety subjects are covered and your learning is assessed, as required for certification as a Safe Food Handler.
                  <ol>
                    <li>Foodborne illness</li>
                    <li>Time/temperature control for safety</li>
                    <li>Employee hygiene</li>
                    <li>Receiving food</li>
                    <li>Storing food</li>
                    <li>Preparing and serving food</li>
                    <li>Cleaning and sanitizing</li>`
        }, {
          title: `Participation requirements`,
          content: `<ul>
                      <li>Have an iPhone or iPad and know how to use mobile apps</li>
                      <li>Download and run the Safe Food Handler mobile app on your iPhone or iPad</li>
                      <li>Register and create an account</li>
                      <li>Pay the license fee of $15 (Discounted for Team Path group participants)</li>
                    </ul>
                  <br>Payment must be made as an In-App Purchase after you have installed and checked out the App.`
        }, {
          title: `Use any of three PATHS to success!`,
          content: `You may be experienced with food safety. Or you're a food-safety beginner. Or you may be a business
          or classroom working with many people.<br><br>
          The Safe Food Handler program recognizes the different training needs people have. The Fast Path, Master Path, and Team Path fit these individual needs.`
        }, {
          title: `What's the FAST PATH?`,
          content: `The Fast Path is how an experienced food handler most efficiently completes the certificate program.
          <ul>
            <li>First, they must use the quiz feature on at least four of the ${MAX_LEVEL_TEXT} levels of instruction. This demonstrates subject
          knowledge.</li>
            <li>They may then take the 40-question exam. They pass with a score of at least 70%, and thereby earn the certificate.</li>
          </ul>`
        }, {
          title: `Why use the MASTER PATH?`,
          content: `The Master Path is how a new or inexperienced food handler builds great expertise.
          Learning Accelerators boost mastery of all ${MAX_LEVEL_TEXT} levels of course instruction.
          The Master Path Learning Accelerators include:
          <ul>
            <li>Coins and peeks that streamline course-info lookup and learning</li>
            <li>Level skill calculations that show exam readiness for each course-instruction level</li>
            <li>Quiz time tracking that develops confidence and speedy recall</li>
          </ul><p>The Master Path is optional but encouraged because it builds mastery.</p>`
        }, {
          title: `Who would use the TEAM PATH?`,
          content: `When the app is used by a group of people, they use the Team Path. Team Tools enhance group play,
          and support individual use of the Fast Path and Master Path features. The Team Path is recommended for any
          group with a shared interest in food safety. From a few friends and coworkers, or businesses and classrooms
          of hundreds of people.`
        }, {
          title: `What are TEAM TOOLS?`,
          content: `Team Tools make for great group training.
          <ul>
            <li>INVITES are used to ask others to join a Safe Food Handler game. Notice the discounted license fee for training game
            participants</li>
            <li>Designated TRAINERS can follow the progress of new trainees</li>
            <li>Course INSTRUCTION can be presented as part of a physical or virtual classroom, using the App's course material
            and Apple TV (or other digital projection system)</li>
            <li>Group CHALLENGES add fun activities into pre-shift meetings or classrooms</li>
            <li>Use of the STANDINGS page and the Top-5 Most Active list makes for a nice team review of daily or weekly progress</li>
            <li>GAME TRAINING REPORTS summarize participation of group members</li>
          </ul>`
        }, {
          title: `How much does it cost?`,
          content: `The payment of a $15 license fee allows full participation in the certificate program. Without the
          payment of the license fee, the participant may access the certificate program as a free trial.
          <br><br>
          As a free trial, the certificate program limits access to just two of the ${MAX_LEVEL_TEXT} levels. And no exam attempts are allowed.
          You can send invites from a free trial game, and then you and all others that join the game can pay discounted license fees.`
        }
        ]
      }
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// src/components/views/guest/Introduction.vue